<img id='imgToExport' src='{{company_logo}}' style='display:none' />
<div class="container-fluid" id="c-f">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card custom-card">
        <div class="card-body">
          <p>PAYMENT HISTORY <br>
            <button mat-raised-button color="primary" (click)="printSummary()">Print Summary</button>
            <button (click)="printClearance()" mat-raised-button mat-button class="ml-2 mat-primary">
              Print Clearance
            </button>
            <button (click)="printClearance2 ()" mat-raised-button mat-button class="ml-2 mat-primary">
              Print Clearance 2
              <!-- Download Clearance PDF -->
            </button>
          </p>
          <div *ngIf="paymentHistory.length == 0">No Invoice(s) Found</div>
          <div class="table-responsive" *ngIf="paymentHistory.length > 0">
            <table class="table">
              <tr>
                <th>Invoice#</th>
                <th>Amount to be Paid</th>
                <th>Amount Paid</th>
                <th>Balance</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
              <tr *ngFor="let h of paymentHistory">
                <td>{{h.category | uppercase}} - {{h.name | uppercase}} - {{h.tag | uppercase}} -
                  {{ h.term | uppercase }}</td>
                <td>{{h.total_amount | currency:'NGN':'symbol-narrow'}}</td>
                <td>{{h.total_paid | currency:'NGN':'symbol-narrow'}}</td>
                <td>{{h.amount_remaining | currency:'NGN':'symbol-narrow'}}</td>
                <td>{{h.date}}</td>
                <td><button mat-raised-button color="primary" (click)="printInvoice(h.invoice_id)">Print</button></td>
                <td>
                  <!-- <button mat-raised-button color="primary" (click)="printPDF(h.invoice_id)">Download</button> -->
                </td>
              </tr>
            </table>
            <hr />
          </div>
        </div>
      </div>

    </div>


  </div>

  <!-- PRINT SECTION 2 -->
  <div id="invoiceSummary" style="width: 100%;visibility: hidden;display: none; font-size: 12px;">
    <table style="width: 100%;">
      <tr>
        <td>
          <img src="{{company_logo}}" style="width:50px;height:50px" />

        </td>
        <td>
          <strong>{{company_name | uppercase}}</strong>
          <div>
            <i [innerHTML]="company_address"></i>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div style='width:100%;border-top:2px solid black;margin-top:3px'>
          </div>
        </td>
      </tr>
    </table>
    <form id="box1">
      <fieldset>
        <legend>Student Info</legend>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">

          <tr style="padding-top: 10px">

            <td rowspan="2"><img name="" src="{{studentData?.passport}}" width="70" alt="Passport" /></td>
            <td><b>Student Name</b></td>
            <td><span class="name" style="text-transform:uppercase;"> <b>{{studentData?.lastname | uppercase}}</b>
                {{studentData?.firstname | uppercase}} <span
                  *ngIf="studentData?.middlename">{{studentData?.middlename| uppercase}}</span></span></td>
            <td><b>Student ID</b>.</td>
            <td>{{studentData?.matric_no}}</td>
          </tr>

          <tr style="border-bottom: 1px solid lightgrey !important">
            <td><b>Gender</b></td>
            <td>{{studentData?.gender | uppercase}}</td>
            <td><b>Class</b></td>
            <td>{{studentData?.category | uppercase}} - {{studentData?.name | uppercase}} -
              {{studentData?.tag | uppercase}}</td>
          </tr>


        </table>
      </fieldset>
    </form>
    <br>
    <div id="box3">
      <table width="100%" border="1" style="border-collapse: collapse !important">
        <tr>
          <th style="text-align: left;padding-left: 10px;">
            Invoice#
          </th>
          <th>
            Amount To Be Paid
          </th>
          <th>
            Amount Paid
          </th>
          <th>
            Percentage Paid
          </th>
          <th>
            Balance
          </th>
          <th>
            Date
          </th>
        </tr>
        <tr *ngFor="let invoice of paymentHistory">
          <td style="text-align: left;padding-left: 10px">
            <p>
              <small style="font-size: 0.5em">{{ invoice.category | uppercase }} -
                {{ invoice.name | uppercase }} -
                {{ invoice.tag | uppercase }} <br />
                {{ invoice.term | uppercase }} - {{invoice.session_year}}</small>
            </p>
          </td>
          <td style="text-align: center;">{{ invoice.total_amount | currency : "NGN" : "symbol-narrow" }}</td>
          <td style="text-align: center;">{{ invoice.total_paid | currency : "NGN" : "symbol-narrow" }}</td>
          <td style="text-align: center;">
            <span *ngIf="invoice.total_amount">
              {{ ((invoice.total_paid/invoice.total_amount)*100).toFixed(2) }}%
            </span>
          </td>
          <td style="text-align: center;"> {{ invoice.amount_remaining | currency : "NGN" : "symbol-narrow"}}</td>
          <td style="text-align: center;">
            {{ invoice.date }}
          </td>

        </tr>

        <tr *ngIf="paymentHistory.length > 0">
          <td style="border:none; text-align: left;  padding-top:2rem; padding-left: 10px">
            <b>TOTAL</b>
          </td>
          <td style="border:none; text-align: center;  padding-top:2rem; ">
            <b>{{ totalAmount | currency : "NGN" : "symbol-narrow" }}</b>
          </td>
          <td style="border:none; text-align: center;  padding-top:2rem; ">
            {{ totalAmountPaid | currency : "NGN" : "symbol-narrow" }}
          </td>
          <td style="border:none; text-align: center;  padding-top:2rem; ">

          </td>
          <td style="border:none; text-align: center;  padding-top:2rem; ">
            <b>{{ totalBalance | currency : "NGN" : "symbol-narrow"}}</b>
          </td>
          <td style="border:none; text-align: center;  padding-top:2rem; ">
          </td>
        </tr>


      </table>
      <div style="margin-top:1rem">
        <div>
          <strong>Percentage paid: {{((totalAmountPaid/totalAmount) * 100).toFixed(2)}}%</strong>
        </div>
      </div>
    </div>
    <br>
    <footer style="position: fixed;bottom:0;right: 0;">
      <p style="letter-spacing: 5px;"> <i>EDOZZIER</i></p>
    </footer>
  </div>

  <!-- PRINT CLEARANCE SECTION 2 -->
  <div id="invoiceClearance" style="width: 100%;visibility: hidden;display: none; font-size: 12px;">
    <table style="width: 100%;">
      <tr>
        <td>
          <img src="{{company_logo}}" style="width:50px;height:50px" />

        </td>
        <td>
          <strong>{{company_name | uppercase}}</strong>
          <div>
            <i [innerHTML]="company_address"></i>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div style='width:100%;border-top:2px solid black;margin-top:3px'>
          </div>
        </td>
      </tr>
    </table>
    <form id="box1">
      <fieldset>
        <legend>Student Info</legend>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">

          <tr style="padding-top: 10px">

            <td rowspan="2"><img name="" src="{{studentData?.passport}}" width="70" alt="Passport" /></td>
            <td><b>Student Name</b></td>
            <td><span class="name" style="text-transform:uppercase;"> <b>{{studentData?.lastname | uppercase}}</b>
                {{studentData?.firstname | uppercase}} <span
                  *ngIf="studentData?.middlename">{{studentData?.middlename| uppercase}}</span></span></td>
            <td><b>Student ID</b>.</td>
            <td>{{studentData?.matric_no}}</td>
          </tr>

          <tr style="border-bottom: 1px solid lightgrey !important">
            <td><b>Gender</b></td>
            <td>{{studentData?.gender | uppercase}}</td>
            <td><b>Class</b></td>
            <td>{{studentData?.category | uppercase}} - {{studentData?.name | uppercase}} -
              {{studentData?.tag | uppercase}}</td>
          </tr>


        </table>
      </fieldset>
    </form>
    <h3 style="display: flex; justify-content: center;">CLASS/EXAM ADMITTANCE SLIP</h3>
    <p>I hereby confirm that <span class="name" style="text-transform:uppercase;">
        <b>{{studentData?.lastname | uppercase}}</b>
        {{studentData?.firstname | uppercase}} <span
          *ngIf="studentData?.middlename">{{studentData?.middlename| uppercase}}</span></span> of
      {{studentData?.category | uppercase}} - {{studentData?.name | uppercase}} -
      {{studentData?.tag | uppercase}} has paid <strong> {{((totalAmountPaid/totalAmount) * 100).toFixed(2)}}% </strong>
      of {{studentData?.gender==='male' ? 'his':'her' }} fee.
      <!-- and thus qualifies for the above. -->
    </p>

    <p style="display: flex; justify-content: end;margin-top: 60px;">...........................................</p>
    <p style="display: flex; justify-content: end;">Name, Signature and Date </p>


    <br>
    <footer style="position: fixed;bottom:0;right: 0;">
      <p style="letter-spacing: 5px;"> <i>EDOZZIER</i></p>
    </footer>
  </div>

  <!-- clearance with new design -->

  <div id="invoiceClearance2" class="hidden">


    <body>
      <div style=" height: 95vh;
                  font-size: 1.1rem;
                  max-width: 75rem;
                  margin: 1rem auto;
                  display: flex;
                  flex-direction: column;
                  gap: 2rem;
                  padding: 2rem 1rem 0;
                  font-family: sans-serif;">

        <img style="position: absolute; height: 18rem; z-index: -10; opacity: .1; right: 0; top: 0;"
          src="{{company_logo}}">
        <div style="display: flex;
                  align-items: center;
                  gap: 1rem;">
          <img style=" width: 3rem; " src="{{company_logo}}" alt="Company Logo">
          <div style="display: flex; flex-direction: column; font-size: 1.15rem;">
            <h3>{{company_name | uppercase}}</h3>
            <div [innerHTML]="company_address"></div>
          </div>
        </div>

        <b style="color: #1A237E;
                  font-size: 1rem;
                  border-top: 1px solid #ccc;
                  border-bottom: 1px solid #ccc;
                  padding: 1rem 0;">
          CLASS/EXAM ADMITTANCE SLIP
        </b>


        <div style="display: flex; align-items: center; gap: 1rem; ">
          <img style="height: 9rem; object-fit: cover; border-radius: .3rem;" src="{{studentData?.passport}}"
            alt="Passport Missing">
          <div class="details-box-container">
            <div>
              <span>Student Name:</span>
              <div>
                <b>{{studentData?.lastname | uppercase}}</b>
                {{studentData?.firstname | uppercase}}
                <span *ngIf="studentData?.middlename">{{studentData?.middlename| uppercase}}</span>
              </div>
            </div>
            <div>
              <span>Student ID.:</span>
              <div>{{studentData?.matric_no}}</div>
            </div>
            <div>
              <span>Gender:</span>
              <div>{{studentData?.gender | uppercase}}</div>
            </div>
            <div>
              <span>Class:</span>
              <div>{{studentData?.category | uppercase}} - {{studentData?.name | uppercase}} -
                {{studentData?.tag | uppercase}}</div>
            </div>
          </div>
        </div>

        <div>
          <p>I hereby confirm that <span class="name" style="text-transform:uppercase;">
              <b>{{studentData?.lastname | uppercase}}</b>
              {{studentData?.firstname | uppercase}} <span
                *ngIf="studentData?.middlename">{{studentData?.middlename| uppercase}}</span></span> of
            {{studentData?.category | uppercase}} - {{studentData?.name | uppercase}} -
            {{studentData?.tag | uppercase}} has paid <strong> {{((totalAmountPaid/totalAmount) * 100).toFixed(2)}}%
            </strong> of {{studentData?.gender==='male' ? 'his':'her' }} fee
            <!-- and thus qualifies for the above. -->
          </p>

          <div class="signatures-container"
            [ngStyle]="{justifyContent:clearanceOffices.length > 1 ? 'space-between' : 'end'}">
            <div style=" display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: .5rem;" *ngFor="let office of clearanceOffices">
              <p>....................................................</p>
              <h5>{{office.role_name | uppercase}}</h5>
            </div>
          </div>
        </div>

        <div style="font-size: .65rem;
                margin-top: auto;
                color: #333;
                display: flex;
                justify-content: end;
                gap: .5rem;
                align-items: center;">
          Powered By
          <a target="_blank" href="https://edozzier.com/">
            <img style=" height: 1rem;
                display: inline;" src="https://edossier.app/admin/assets/img/edozzier-log.png" />
          </a>
        </div>
      </div>
    </body>
  </div>


</div>